export function deepEqual<T>(a: T, b: T): boolean {
  if (a === b) return true;

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (Array.isArray(a) !== Array.isArray(b)) return false;

    const keysA = Object.keys(a as object);
    const keysB = Object.keys(b as object);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      const k = key as keyof T;
      if (!(key in (b as object))) return false;
      if (!deepEqual(a[k], (b as any)[k])) return false;
    }

    return true;
  }

  return false;
}

export function deepSubsetEqual<Sub extends object, T extends object>(
  subset: Sub,
  target: T,
): boolean {
  if (subset === target) return true;

  // Handle nulls and primitives
  if (
    subset === null ||
    target === null ||
    typeof subset !== 'object' ||
    typeof target !== 'object'
  ) {
    return subset === target;
  }

  // Handle arrays (unordered)
  if (Array.isArray(subset)) {
    if (!Array.isArray(target)) return false;
    if (subset.length > target.length) return false;

    return subset.every((subItem) => target.some((tItem) => deepSubsetEqual(subItem, tItem)));
  }

  // Handle objects
  for (const key of Object.keys(subset) as (keyof Sub)[]) {
    if (!(key in target)) return false;
    if (!deepSubsetEqual(subset[key], (target as any)[key])) return false;
  }

  return true;
}
